export const fetchQueryParams = <Params extends object>(defaultParams: Params): Partial<Params> => {
  const params = new URLSearchParams(location.search);
  const keys = [...new Set(params.keys())];

  const searchParams: Record<string, string | string[]> = {};
  keys.forEach((key: string): void => {
    const values = params.getAll(key);
    if (values.length <= 0) {
      return;
    }

    key = key.replace(/\[\]$/, '');
    if (Array.isArray((defaultParams as Record<string, unknown>)[key])) {
      searchParams[key] = values;
    } else {
      searchParams[key] = values[0];
    }
  });
  return searchParams as Partial<Params>;
};

export const createSearchParams = <Params extends object>(params: Params): URLSearchParams => {
  const searchParams = new URLSearchParams();
  Object.keys(params).forEach((key: string): void => {
    const value = (params as Record<string, unknown>)[key];
    if (!value) {
      return;
    }

    if (Array.isArray(value)) {
      const arrayKey = `${key}[]`;
      searchParams.delete(arrayKey);
      value.forEach((item: string) => { searchParams.append(arrayKey, item); });
    } else {
      searchParams.set(key, String(value));
    }
  });
  return searchParams;
};
